import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuditServiceProvider } from '../../api/audit'

const AuditService = AuditServiceProvider()
const name = 'getAllAudit'

export default () => (asyncAction(
  name,
  AuditService.getAllAudit,
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/audit/getAllAudit.js